import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';
import { light } from '@mui/material/styles/createPalette';
import spinwerad from './assets/fonts/spinwerad.ttf';

const myColors = {
  primary: '#D64933',
  background: "#dde2c6",
  secondary: '#545e71',
  secondaryContrastText: 'white',
  secondaryBackground: 'white'
};

// A custom theme for this app
const theme = createTheme({
  cssVariables: true,
  palette: {
    primary: {
      main: myColors.primary,
      contrastText: myColors.primary,
    },
    secondary: {
      main: myColors.secondary,
      light: myColors.secondaryBackground,
      contrastText: myColors.secondaryContrastText,
    },
    text: {
      primary: myColors.primary,
    },
    background: {
      default: myColors.background,

    },
  },
  typography: {
    // fontFamily: 'Times New Roman',
    // fontFamily: 'Brush Script MT',
    // fontFamily: 'Courier New',
    fontFamily: 'Courier New, spinwerad',
    fontSize: 16,
    h1: {
      fontSize: 120,
      '@media (max-width:600px)': {
        fontSize: '4rem',
      },
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'spinwerad';
          font-style: normal;
          font-display: swap;
          font-weight: 500;
          src: local('spinwerad'), local('spinwerad'), url(${spinwerad}) format('truetype');
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }
      `,
    },
  },
});

export default theme;
